export default {
  Extract: {
    CHECKING: 'Checking for extracts',
    STOPPED: 'Sync with sources',
    EXTRACTING: 'Syncing...',
    COMPLETE: 'Sync with sources',
    NOTICE: {
      SUCCESS: {
        TITLE: 'Success',
        MESSAGE: 'The sync of data & transactions has completed.',
      },
      PARTIAL: {
        TITLE: 'Partial Sync',
        MESSAGE_1:
          'Some orgs are disconnected and we could not sync their data. We were able to sync the data for all other orgs.',
        MESSAGE_2: 'Please either re-connect the other orgs or archive them.',
      },
      FAILURE: {
        TITLE: 'Oops',
        MESSAGE:
          'There was a problem syncing data with your sources. If this persists, please use the chat bot in the bottom-right so we can investigate further.',
      },
    },
  },
};
